import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IPricingList } from "../../../Pages/Pricing/IPricing";

export const PricingSlicer = createSlice({
  name: 'Pricing',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IPricingList[]>,
  reducers: {
    getPricing: (state, _) => {
      state.isLoading = true;
    },
    successGetPricing: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetPricing: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getPricing, successGetPricing, failureGetPricing } =
  PricingSlicer.actions;

export default PricingSlicer.reducer;
